<!-- <p>khatma-details works! {{khatmaId}}</p> -->

<recitations-list [khatmaId]="khatmaId" [reciterName]="''"></recitations-list>